<template>
	<v-card>
		<div id="sectionView" tile class="pa-0 chart-board" ref="section_view"></div>
	</v-card>
</template>

<script>
import "./style.css";
import { register, unregister } from "@/utils/chartViewUpdaters";

export default {
	name: "SectionViewDialog",
	props: {
		id: String,
	},

	mounted() {
		this.updateBound = this.update.bind(this);
		register(this.updateBound);

		// Set legend labels with existing i18n keys
		if (window["viewer"]) {
			window["viewer"].setSectionViewLabels({
				pointCloudOutlines: this.$t("POINT_CLOUD"),
				pathPoints: this.$t("OBJECT_DATA"),
				designDataOutlines: this.$t("DesignData"),
				referenceTopologyOutlines: this.$t("DRAWING_2D_IMAGE"),
				flatGroundDataOutlines: this.$t("FLAT_GROUND"),
			});
		}

		this.$nextTick(() => {
			this.update();
		});
	},
	beforeUnmount() {
		unregister(this.updateBound);
	},
	data: () => ({
		updateBound: null,
	}),
	methods: {
		update() {
			const canvas =
				window["viewer"] && window["viewer"].getCanvasForView("sectionView");
			const element = this.$refs.section_view;
			if (canvas && element) {
				for (const node of element.children) {
					element.removeChild(node);
				}
				element.appendChild(canvas);
				canvas.height = element.getBoundingClientRect().height;
				canvas.width = element.getBoundingClientRect().width;
				window["viewer"].resize2dView(
					{ width: canvas.width, height: canvas.height },
					"sectionView",
				);
			}
		},
	},
};
</script>

<style scoped>
.v-card {
	display: flex;
	flex-direction: column;
}

.chart-board {
	flex: 1;
	min-height: 0;
}
</style>
